import React, { Component } from 'react';

import { LineChart, Line, XAxis, YAxis, Tooltip } from 'recharts';
import GenericTooltip from './../GenericTooltip';

import Grid from '@material-ui/core/Grid';

import ChartMenu from './../ChartMenu/ChartMenu'
// import CustomizedDot from './CustomizedDot';
import { colors, colors1, colors2, colors3, colors4 } from '../../../../constants//icons/characteristics/Characteristics';




class DetailLineComponent extends Component {
  state = {
    type: 'line',
    colors: colors
  }
  getData = () => {
    const { data } = this.props;
    let resp = [];
    for (let i = 0; i < data.dataSet.length; i++) {
      let temp
      for (let j = 0; j < data.dataSet[i].value.length; j++) {
        temp = {
          name: data.dataSet[j].name
        }
      }
      if (data[i] !== 0) {
        temp = {
          name: i.toString(),
          val: data[i]
        }
        resp.push(temp);
      }
    }
    return resp;
  }

  // getLine = () => {
  //     try{
  //         return this.props.data.map((val, index) => {
  //             return <Line type="monotone" dataKey={val.name} 
  //             stroke={this.state.colors[index % this.state.colors.length]} 
  //             dot={<CustomizedDot fill={this.state.colors[index % this.state.colors.length]} />} 
  //             isAnimationActive={false}
  //             />
  //         })
  //     }catch(e){}
  // }

  getTotal = () => {
    const { data } = this.props;
    let resp = 0;
    for (let i = 0; i < data.length; i++) {
      resp += data[i];
    }
    return <p style={{ fontWeight: 'bold' }}>{'Total: ' + resp} </p>;
  }



  getWidth = () => {
    if (this.props.name.toString().includes('linea'))
      return 400;
    return 500;
  }
  getMonthId = (month) => {
    switch (month) {
      case 'Ene': return 1;
      case 'Feb': return 2;
      case 'Mar': return 3;
      case 'Abr': return 4;
      case 'May': return 5;
      case 'Jun': return 6;
      case 'Jul': return 7;
      case 'Ago': return 8;
      case 'Sep': return 9;
      case 'Oct': return 10;
      case 'Nov': return 11;
      case 'Dic': return 12;
      default: return 1;
    }

  }
  onClick = (uno) => {
    try {
      if (isNaN(uno.activeLabel)) {
        this.props.onClickGraphic('month', { id: this.getMonthId(uno.activeLabel), value: uno.activeLabel })
      } else {
        this.props.onClickGraphic('year', { year: Number(uno.activeLabel) })
      }
    } catch (e) { }
  }

  onChangeGraph = () => {
    if (this.state.type === 'line') {
      this.setState({ type: 'bar' });
    } else {
      this.setState({ type: 'line' });
    }
  }

  onChangeColor = (color) => {
    if (color === 'Azul') {
      this.setState({ colors: colors })
    } else if (color === 'Rojo') {
      this.setState({ colors: colors1 })
    } else if (color === 'Verde') {
      this.setState({ colors: colors2 })
    } else if (color === 'Gris') {
      this.setState({ colors: colors3 })
    } else if (color === 'Azul-Gris') {
      this.setState({ colors: colors4 })
    }
  }

  render() {
    return (
      <Grid style={{ flexWrap: "inherit", margin: 'auto' }} id={this.props.name}  >
        <ChartMenu graph={this.props.name} file={this.props.title} onCloseMenu={this.handleClose} title={this.props.title} watch={this.props.watchMenu}
          seeMore={this.props.seeMore}
          onChangeGraph={this.onChangeGraph}
          changeGraph={true}
          changeColor={true}
          onChangeColor={this.onChangeColor}
          openDialog={this.props.openDialog}
        />
        <Grid container>
          <Grid item xs={9}>
            {
              // (this.state.type == 'line') ?
              <LineChart width={this.getWidth()} height={250} data={this.props.data}
                margin={{ top: 5, right: 30, bottom: 5 }}
                onClick={this.onClick}
              >
                <XAxis dataKey="name" fontSize={12} />
                <YAxis dataKey='value' fontSize={12} allowDecimals={false} />
                <Tooltip content={
                  <GenericTooltip
                    data={this.props.data}
                    colors={this.state.colors}
                  />}
                />
                <Line type="monotone" dataKey="value" stroke={this.state.colors[0]} />
                {/* {
                                    this.getLine()
                                } */}
              </LineChart>
              // :
              // <BarChart width={this.getWidth()} height={250} data={this.getData()}
              //     margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
              //     onClick={this.onClick}>
              //     {/* <CartesianGrid strokeDasharray="3 3" /> */}
              //     <XAxis dataKey="name"  interval={0} fontSize={12}  allowDecimals={false}/>
              //     <YAxis  fontSize={12} />
              //     <Tooltip />
              //     <Legend />
              //     {
              //         this.props.data.map((val, index) => {
              //             return <Bar type="monotone" dataKey={val.name} 
              //             fill={this.state.colors[index % this.state.colors.length]} 
              //              />
              //         })
              //     }
              // </BarChart>
            }
          </Grid>
        </Grid>
      </Grid>
    )
  }
}

export default DetailLineComponent; 